module.exports = __webpack_public_path__ + "95cd33d6a0fb46dc7a6283e9f12e7151.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/navigation/logo@2x.png
// module id = 771
// module chunks = 0